var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Address"},[_c('FieldSet',{class:{ 'inline-four-columns': _vm.inlineColumns },attrs:{"label":_vm.label,"values":_vm.values,"fields":_vm.fields,"validation":_vm.validation,"layout":_vm.layout,"path":_vm.path},on:{"input":_vm.handleInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }